import React from "react"

const Contactbar = () => <div>full-width</div>

export default Contactbar
